// extracted by mini-css-extract-plugin
export var fadeIn = "_dg-1";
export var modalContent = "_dg-3";
export var overlay = "_dg-0";
export var popoverContent = "_dg-2";
export var results = "_dg-5";
export var searchInputWrapper = "_dg-4";